<template>
  <div>
    <Dialog
      :key="mainDialogKey"
      :visible.sync="quotationSelectionDialog1"
      :style="{ width: '800px', height: '600px', overflowY: 'auto' }"
      :modal="true"
      :closable="true"
      :closeOnEscape="true"
      header="Quotation Selection"
      class="p-fluid"
      :maximizable="true"
    >
      <template>
        <span class="p-input-icon-left">
          <i class="pi pi-search" />
          <InputText
            v-model="filters['global']"
            placeholder="Global Search"
            style="margin-right: 0.5em"
            @input="updateSearch"
          />
        </span>
      </template>

      <Message v-for="msg of messages" severity="info" :key="msg.content">
        {{ msg }}
      </Message>

      <br />
      <div v-if="requestingQuotations" style="width: 100%; text-align: center;">
        <ProgressSpinner
          style="width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
      </div>
      <DataTable
        :value="quotations3"
        :filters="filters"
        :selection.sync="selectedQuotation"
        @row-select="onRowSelect"
        dataKey="quoteVerId"
        class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers p-my-4"
        :scrollable="true"
        scrollHeight="200px"
        :loading="loading"
        :lazy="true"
        :rows="20"
        :virtualScroll="true"
        :virtualRowHeight="45"
        @virtual-scroll="onVirtualScroll"
        :totalRecords="lazyTotalRecords"
        selectionMode="single"
      >
        <template #header>
          Quotations
        </template>

        <Column
          field="quoteVer"
          header="Quote Version"
          :sortable="true"
          headerStyle="width: 5em; text-align: center"
        >
          <template #loading>
            <span class="loading-text"></span>
          </template>
        </Column>
        <Column
          field="quoteVerDate"
          header="Quote Version Date"
          :sortable="true"
          headerStyle="width: 15em; text-align: center"
        >
          <template #loading>
            <span class="loading-text">loading</span>
          </template>
        </Column>
        <Column
          field="opportunity.oppDescription"
          header="Address"
          :sortable="true"
          headerStyle="width: 7em; text-align: center"
        >
          <template #loading>
            <span class="loading-text">loading</span>
          </template>
          <template #body="slotProps">
            {{
              slotProps.data && slotProps.data.opportunity
                ? slotProps.data.opportunity.oppDescription
                : ""
            }}
          </template>
        </Column>
        <Column
          field="productValue"
          header="Customer"
          :sortable="true"
          headerStyle="width: 7em; text-align: center"
        >
          <template #loading>
            <span class="loading-text"></span>
          </template>
        </Column>
        <Column
          field="quoteStatus.statusName"
          header="Status"
          :sortable="true"
          headerStyle="width: 7em; text-align: center"
        >
          <template #body="slotProps">
            <span :class="'ignore pointer badge ' + getStyle(slotProps.data)">
              {{
                slotProps.data &&
                slotProps.data.quoteStatus &&
                slotProps.data.quoteStatus.statusName
                  ? slotProps.data.quoteStatus.statusName
                  : ""
              }}
            </span>
          </template>
          <template #loading>
            <span class="loading-text"></span>
          </template>
        </Column>
      </DataTable>

      <template #footer>
        <Button
          class="p-button-success p-mr-2"
          label="Select"
          @click="select"
          style="width: auto"
        />
        <Button
          class="p-button-secondary p-mr-2"
          label="Cancel"
          @click="$emit('close')"
          style="width: auto"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import QuotationService from "@/service/QuotationService";

export default {
  name: "QuotationSelection",
  props: {
    quotationSelectionDialog: {
      type: Boolean,
      requrired: false
    },
    quotations: {
      type: Array,
      required: false
    },
    requestingQuotations: {
      type: Boolean,
      requrired: false
    }
  },
  data: () => ({
    quotationService: new QuotationService(),
    lazyTotalRecords: 0,
    quotations1: [],
    quotations2: null,
    quotations3: [],
    selectedQuotation: {},
    filters: {},
    messages: [],
    mainDialogKey: 0,
    requesting: false
  }),
  computed: {
    loading() {
      if (this.quotations2 && this.quotations2[0]) {
        return false;
      } else {
        if (this.requesting) {
          return true;
        } else {
          return false;
        }
      }
    },
    quotationSelectionDialog1: {
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
      get() {
        if (this.quotationSelectionDialog) {
          this.setupQuotations(); // its like reloading this component
          return true;
        } else {
          return false;
        }
      }
    }
  },
  created() {
    this.setupQuotations();
  },
  watch: {
    requesting(val) {},
    quotations2(val) {
      if (val && val[0]) {
        this.quotations3 = this.loadChunk(0, 40);
        this.lazyTotalRecords = val.length;
      }
    }
  },
  methods: {
    setupQuotations() {
      if (this.quotations) {
        this.quotations1 = this.quotations;
        this.quotations2 = this.quotations;
      } else {
        this.getAllQuotations();
      }
      this.mainDialogKey++;
    },
    getStyle(data) {
      // according to: https://www.w3schools.com/bootstrap4/tryit.asp?filename=trybs_badges2&stacked=h
      if (data && data.quoteStatus && data.quoteStatus.colourCode) {
        return data.colourCode;
      } else if (
        data &&
        data.quoteStatus &&
        data.quoteStatus.statusName &&
        data.quoteStatus.statusName.toLowerCase() === "lost"
      ) {
        return "badge-danger";
      } else if (
        data &&
        data.quoteStatus &&
        data.quoteStatus.statusName &&
        data.quoteStatus.statusName.toLowerCase() === "active"
      ) {
        return "badge-primary";
      } else if (
        data &&
        data.quoteStatus &&
        data.quoteStatus.statusName &&
        data.quoteStatus.statusName.toLowerCase() === "won"
      ) {
        return "badge-success";
      } else if (
        data &&
        data.quoteStatus &&
        data.quoteStatus.statusName &&
        data.quoteStatus.statusName.toLowerCase() === "cancelled"
      ) {
        return "badge-warning";
      } else if (
        data &&
        data.quoteStatus &&
        data.quoteStatus.statusName &&
        data.quoteStatus.statusName.toLowerCase() === "revised"
      ) {
        return "badge-info";
      } else if (
        data &&
        data.quoteStatus &&
        data.quoteStatus.statusName &&
        data.quoteStatus.statusName.toLowerCase() === "closed"
      ) {
        return "badge-secondary";
      } else {
        return "badge-dark";
      }
    },
    loadChunk(index, length) {
      let chunk = [];
      for (let i = 0; i < length; i++) {
        chunk[i] = this.quotations2[index + i];
      }
      return chunk;
    },
    getAllQuotations() {
      this.requesting = true;
      this.quotationService
        // .getAllQuotations()
        .getAllActiveQuotations()
        .then(data => {
          this.requesting = false;

          this.quotations1 = data;
          this.quotations2 = data;
        })
        .catch(e => {
          this.requesting = false;

          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error while getting quotations",
            life: 5000
          });
        });
    },
    updateSearch(e) {
      if (!e) {
        this.quotations2 = this.quotations1;
      } else {
        var a = [];
        this.quotations1.forEach(opportunity => {
          let b = Object.keys(opportunity);
          for (let i = 0; i < b.length; i++) {
            if (
              opportunity[b[i]] &&
              typeof opportunity[b[i]] === "string" &&
              opportunity[b[i]].search(e) >= 0
            ) {
              a.push(opportunity);
              break;
            }
          }
        });
        //
        this.quotations2 = a;
      }
    },
    onRowSelect(event) {
      this.selectedQuotation = event.data;
    },
    onVirtualScroll(event) {
      setTimeout(() => {
        //last chunk
        if (event.first === this.lazyTotalRecords - 40)
          this.quotations3 = this.loadChunk(event.first, 40);
        else this.quotations3 = this.loadChunk(event.first, event.rows);
      }, 250);
    },
    select() {
      if (this.selectedQuotation)
        this.$emit("selected", this.selectedQuotation);
    }
  }
};
</script>

<style scoped>
.pointer {
  font-size: 15px;
}
</style>
